import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-emailv3",
  "use": "icon-emailv3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-emailv3\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.333 6.176V5h13.334v1.176L10 9.88 3.333 6.176Zm-1.666.474v9.183c0 .46.373.834.833.834h15c.46 0 .833-.373.833-.834V4.167a.833.833 0 0 0-.833-.834h-15a.833.833 0 0 0-.833.834V6.65Zm15 1.433V15H3.333V8.083l5.858 3.254c.503.28 1.115.28 1.618 0l5.858-3.254Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol